// Privacy configuration for data collection - Legal compliance focused
export const PRIVACY_CONFIG = {
  // Data collection settings - Required for legal compliance and audit trails
  COLLECT_IP_ADDRESSES: true,            // Required for audit trails and legal compliance
  COLLECT_USER_AGENTS: true,            // Required for authentication and security
  COLLECT_DEVICE_FINGERPRINTS: true,    // Optional but recommended for audit trails
  ENABLE_ANALYTICS: false,              // Still disabled - not required for legal compliance
  
  // Legal compliance and audit trail requirements
  LEGAL_COMPLIANCE_MODE: true,          // Collect data required by law and best practices
  AUDIT_TRAIL_ENHANCED: true,           // Enhanced audit data for legal protection
  
  // Data retention periods (in days) - Following industry standards
  IP_RETENTION_DAYS: 2555,              // 7 years - standard for legal compliance
  ANALYTICS_RETENTION_DAYS: 0,          // Don't retain analytics data
  AUDIT_RETENTION_DAYS: 2555,           // 7 years for legal compliance
  
  // Legal audit trail requirements
  COLLECT_AUTHENTICATION_DATA: true,    // Authentication methods and attempts
  COLLECT_DOCUMENT_ACCESS: true,        // Document viewing and interaction data
  COLLECT_SIGNATURE_METADATA: true,     // Enhanced signature verification data
  REQUIRE_EXPLICIT_CONSENT: false,      // Not required for legal compliance data
};

export const PRIVACY_NOTICES = {
  DATA_COLLECTION: "We collect data necessary to provide secure digital signature services and maintain legally compliant audit trails.",
  IP_COLLECTION: "IP addresses are collected and stored for audit trail purposes and legal compliance (industry standard practice).",
  ANALYTICS: "Basic usage analytics may be collected to improve service quality. No personal data is shared with third parties.",
  AUDIT_TRAIL: "Comprehensive audit trails are maintained for legal compliance, including IP addresses, timestamps, and authentication data.",
  LEGAL_COMPLIANCE: "All data collection follows industry best practices for digital signature legal enforceability.",
};

export const getPrivacyCompliantValue = (value: string, dataType: 'ip' | 'userAgent' | 'fingerprint'): string => {
  switch (dataType) {
    case 'ip':
      return PRIVACY_CONFIG.COLLECT_IP_ADDRESSES ? value : '';
    case 'userAgent':
      return PRIVACY_CONFIG.COLLECT_USER_AGENTS ? value : 'Privacy Protected';
    case 'fingerprint':
      return PRIVACY_CONFIG.COLLECT_DEVICE_FINGERPRINTS ? value : '';
    default:
      return '';
  }
};